.kj{padding:0.375rem;}